export default __webpack_public_path__ + "static/community-9ec0b2ce96051341e62814836fe798c2.jpg";